import Footer from './StudioEmailFooter';
import Header from './StudioEmailHeader';

export default { Header, Footer };
